export const oddsLabels = {
  '1x2': '1X2',
  'FIRST HALF': 'First half',
  'SECOND HALF': 'Second half',
  OVER_UNDER: 'Over/Under',
  DOUBLE_CHANCE: 'Double chance',
  BOTH_TO_SCORE: 'Both to score',
  DRAW_NO_BET: 'Draw No Bet',
  FIRST_TEAM_TO_SCORE: 'First team to score',
  CORRECT_SCORE: 'Correct score',
  FIRST_HALF_GOALS: 'First half goals',
  FIRST_PLAYER_TO_SCORE: 'First player to score',
  PLAYER_TO_SCORE_DURING_GAME: 'Player to score during game',
  PLAYER_TO_RECEIVE_CARD: 'Player to receive card',
  FIRST_HALF_AND_FINAL_RESULT: 'First half and final result',
  over: 'Over',
  under: 'Under',
  yes: 'Yes',
  no: 'No',
};

export const footballSingleEventLabels = {
  ...oddsLabels,
  fu_win_question: 'Who will win?',
  fu_draw: 'Draw',
  fu_play_free: '',
  round: 'Round',
  in_regular_time: 'In regular time',
  after_penalties: 'After penalties',
  aggregate: 'Agg.',
  penalty_goal: 'P',
  own_goal: 'OG',
};

export const footballLineupsLabels = {
  first_team: 'Starting lineups',
  substitutes: 'Substitutes',
  no_data: 'No data to display',
  substituted_players: 'Substituted Players',
  formation: 'Formations',
};

export const footballTeamH2HLabels = {
  defeats: 'Defeats',
  draw: 'Draws',
  goals_conceded: 'Goals conceded',
  goals_scored: 'Goals scored',
  played: 'Played',
  win: 'Wins',
  points: 'Points',
  rank: 'Rank',
};

export const footballTeamMatchH2HLabels = {
  corners: 'Corners',
  counter_attacks: 'Counter attacks',
  crosses: 'Crosses',
  fouls_committed: 'Fouls committed',
  goal_kicks: 'Goal kicks',
  goals: 'Goals',
  offside: 'Offside',
  possession: 'Possession',
  red_cards: 'Red cards',
  shots_blocked: 'Shots blocked',
  shots_off: 'Shots off',
  shots_on: 'Shots on',
  substitutions: 'Substitutions',
  throw_in: 'Throw in',
  treatments: 'Treatments',
  yellow_cards: 'Yellow cards',
};

export const footballStandingsLabels = {
  team: 'Team',
  matches_won_short: 'MW',
  points_short: 'P',
  matches_played_short: 'MP',
  match_losses_short: 'L',
  match_draws_short: 'D',
  goal_difference_short: 'GD',
  team_form_short: 'F',
  team_form: 'TEAM FORM',
  matches_played: 'MATCHES PLAYED',
  goal_difference: 'GOAL DIFFERENCE',
  points: 'POINTS',
  matches_won: 'MATCHES WON',
  match_draw: 'MATCH DRAWS',
  match_losses: 'MATCH LOSSES',
  footer_win: 'Win',
  footer_loss: 'Loss',
  footer_draw: 'Draw',
};

export const footballTimelineLabels = {
  on_for: 'on for',
  assist_by: 'assist by',
  half_time: '1st half-time',
  finished_after_extra_time: 'finished after extra time',
  finished_after_penalties: 'finished after penalties',
  first_half_time_finish: '1st half-time',
  second_half_time_finish: '2nd half-time',
  game_starts: 'Game starts',
  no_events_yet: 'No events yet',
  minutes: 'min',
};

export const footballMatchCenterLabels = {
  ...footballSingleEventLabels,
  ...footballLineupsLabels,
  ...footballTeamMatchH2HLabels,
  ...footballStandingsLabels,
  ...footballTimelineLabels,
  match_information: 'MATCH INFORMATION',
  match_info_time: 'Date and time',
  match_info_venue: 'Venue',
  match_info_referee: 'Referee',
  match_info_spectators: 'Attendance',
  match_info_competition: 'Competition',
  match_information_tab: 'Information',
  match_timeline_tab: 'Timeline',
  match_statistics_tab: 'Statistics',
  match_standings_tab: 'Standings',
  match_playoff_tab: 'Playoff',
  match_odds_tab: 'Odds',
  match_h2h_tab: 'H2H',
};

export const playerStatisticLabels = {
  played: 'Played',
  saves: 'Saves',
  cleansheets: 'Clean sheets',
  conceded: 'Conceded',
  caught_ball: 'Caught ball',
  penalties_saved: 'Penalties saved',
  goals: 'Goals',
  assists: 'Assists',
  minutes: 'Minutes',
  started: 'Started',
  red_cards: 'Red cards',
  yellow_cards: 'Yellow cards',
  substitute_in: 'Substitute in',
  substitute_out: 'Substitute out',
  goals_substitute: 'Goals as substitute',
  minutes_substitute: 'Minutes as substitute',
  penalty_goals: 'Penalty goals',
  own_goals: 'Own goals',
  shots: 'Shots',
  shots_on_target: 'Shots on target',
  offsides: 'Offsides',
  fouls_committed: 'Fouls committed',
  penalties_committed: 'Penalties committed',
  penalties_missed: 'Penalties missed',
  penalties_received: 'Penalties received',
};

export const teamStatisticLabels = {
  played: 'Played',
  win: 'Win',
  goals_scored: 'Goals scored',
  goals_conceded: 'Goal conceded',
  draw: 'Draw',
  defeats: 'Defeats',
  rank: 'Rank',
  points: 'Points',
};

export const playoffLabels = {
  prev_stage_btn: 'Previous stage',
  next_stage_btn: 'Next stage',
};
